import { usePlan, useServiceTypePlace } from '@church/data'
import { createFileRoute } from '@tanstack/react-router'
import { SermonHubPage } from '../components/services/SermonHub.tsx'
import { ErrorNote, PageHeader, Spinner } from '../components/ui.tsx'
import { useBreadcrumbs } from '../lib/breadcrumbs.ts'
import { folderCrumbs } from '../lib/services-crumbs.ts'
import { useTintFromImage } from '../lib/top-bar.ts'
import { seriesArtUrl } from '@church/data'

/**
 * A plan's Sermon page (docs/15, "Sermon writing"): its series' art, the
 * sermon, the ideas written from it and the songs suggested for it. Reached
 * from the plan (its Ideas card on a computer, the Series section on a
 * phone); the old Suggestions page leads here.
 */
export const Route = createFileRoute('/_authed/_shell/services/plans/$id_/sermon')({
  component: SermonScreen,
})

function SermonScreen() {
  const { id } = Route.useParams()
  const planQuery = usePlan(id)
  const plan = planQuery.data
  const place = useServiceTypePlace(plan?.serviceTypeId ?? null)
  // The top bar takes the series' art's colour, as the plan does.
  useTintFromImage(
    plan?.series?.hasArt ? seriesArtUrl(plan.series.id, plan.series.artVersion) : null,
  )
  useBreadcrumbs([
    ...folderCrumbs(place.folders),
    ...(plan
      ? [
          { label: plan.serviceTypeName, href: `/services/types/${plan.serviceTypeId}` },
          { label: 'Plan', href: `/services/plans/${plan.id}` },
          { label: 'Sermon' },
        ]
      : []),
  ])
  if (planQuery.isLoading) return <Spinner />
  if (!plan) return <ErrorNote error={planQuery.error} />
  return (
    <>
      <PageHeader title="Sermon" />
      <SermonHubPage plan={plan} />
    </>
  )
}
